module.exports = __webpack_public_path__ + "img/page_image_3_5.a8a85d0f.svg";